<script>
export default {
  props: {
    selectedData: {
      type: [Array, Object],
      default: () => [],
    },
  },
  data() {
    return {
      showModal: false,
      selectedMember: null, // For name and email
    };
  },
  computed: {
    filteredEvents() {
      return Array.isArray(this.selectedData) ? this.selectedData : [];
    },
    fieldColumns() {
      return [
        { key: "label", label: "Field" },
        { key: "value", label: "Value" },
      ];
    },
  },
  methods: {
    closeModal() {
      this.showModal = false;
    },

  },
};
</script>


<template>
  <b-modal
      id="view_events_fields"
      v-model="showModal"
      title="Event Member Details"
      title-class="font-weight-bold"
      size="lg"
      centered
  >
    <div v-if="selectedMember" class="mb-4">
      <h5 class="mb-1">
        {{ selectedMember.first_name }} {{ selectedMember.last_name }}
      </h5>
      <p class="text-muted mb-0">{{ selectedMember.email }}</p>
    </div>

    <b-table
        :items="filteredEvents"
        :fields="fieldColumns"
        striped
        hover
        bordered
        small
        responsive
        class="mb-3"
    >
      <template #cell(label)="data">
        <span class="font-weight-bold">{{ data.item.label }}</span>
      </template>

      <template #cell(value)="data">
        <span class="text-dark">{{ data.item.value }}</span>
      </template>
    </b-table>

    <template #modal-footer>
      <b-button variant="secondary" @click="closeModal">Close</b-button>
    </template>
  </b-modal>
</template>

